const path = '$home';

 
export const NOTICEPOPUP_SET = `${path}/noticepopup/set`; 
export const NOTICEPOPUP_GET = `${path}/noticepopup/get`; 

export const NOTICEPOPUP_MODAL_SET = `${path}/noticepopup/modal/set`; 
export const NOTICEPOPUP_MODAL_GET = `${path}/noticepopup/modal/get`; 